import React, { PropTypes } from 'react'
import classNames from 'classnames'
import CloseButton from '../../Header/CloseButton'
import { THEME } from '../constants'
import styles from './style.styl'

function ModalOverlay(props) {
  const { children, theme } = props
  return (
    <div className={classNames(
           styles.ModalOverlay,
           {
             [styles['ModalOverlay--light']]: theme === THEME.LIGHT,
             [styles['ModalOverlay--dark']]: theme === THEME.DARK,
           }
    )}>
      {children}
    </div>
  )
}
ModalOverlay.propTypes = {
  theme: PropTypes.oneOf([THEME.LIGHT, THEME.DARK]),
}
ModalOverlay.defaultProps = {
  theme: THEME.LIGHT,
}

export default function Modal(props) {
  const { onCloseClick, theme, children } = props

  const closeButton = onCloseClick ? (
    <CloseButton className={styles.CloseButton}
                 onClose={onCloseClick}
                 color='#9a9a9a'/>
  ) : null

  return (
    <ModalOverlay theme={theme}>
      { closeButton }
      <div className={`${styles.ModalContent} flex-column flex-center`}>
        {React.cloneElement(children, { theme })}
      </div>
    </ModalOverlay>
  )
}
Modal.propTypes = {
  children: PropTypes.any,
  // Event handler for when close button clicked
  onCloseClick: PropTypes.func.isRequired,
  theme: PropTypes.oneOf([THEME.LIGHT, THEME.DARK]),
}
Modal.defaultProps = {
  theme: THEME.LIGHT,
}



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/widget/TakeoverCampaign/Modal/index.js